import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { urlEndPoints } from '../config/end-points';
import { nightNeedsList } from '../models/nightNeedsList.model';

@Injectable({
  providedIn: 'root',
})
export class NightNeedsListDAL {
  constructor(private httpClient: HttpClient) {}

  deleteNightNeedsList(id: string): Observable<any> {
    return this.httpClient.delete<any>(`${urlEndPoints.nightNeedsLists}${id}`);
  }

  updateNightNeedsList(id: string, cycle: nightNeedsList): Observable<any> {
    return this.httpClient.put<any>(`${urlEndPoints.nightNeedsLists}${id}`, cycle);
  }

  createNightNeedsList(cycle: nightNeedsList): Observable<any> {
    return this.httpClient.post<any>(`${urlEndPoints.nightNeedsLists}`, cycle);
  }

  getNightNeedsLists(positions: string): Observable<any> {
    return this.httpClient.get<any>(`${urlEndPoints.nightNeedsLists}?positions=${positions}`);
  }
}
